import _classCallCheck from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/zuberalam/Desktop/random-variation/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// Author Mark Meeus 2019
import { Note } from './note';
import { KeySignature } from './keysignature';
export var KeySigNote = /*#__PURE__*/function (_Note) {
  _inherits(KeySigNote, _Note);

  function KeySigNote(keySpec, cancelKeySpec, alterKeySpec) {
    var _this;

    _classCallCheck(this, KeySigNote);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KeySigNote).call(this, {
      duration: 'b'
    }));

    _this.setAttribute('type', 'KeySigNote');

    _this.keySignature = new KeySignature(keySpec, cancelKeySpec, alterKeySpec); // Note properties

    _this.ignore_ticks = true;
    return _this;
  }

  _createClass(KeySigNote, [{
    key: "getBoundingBox",
    value: function getBoundingBox() {
      return _get(_getPrototypeOf(KeySigNote.prototype), "getBoundingBox", this).call(this);
    }
  }, {
    key: "addToModifierContext",
    value: function addToModifierContext() {
      /* overridden to ignore */
      return this;
    }
  }, {
    key: "preFormat",
    value: function preFormat() {
      this.setPreFormatted(true);
      this.keySignature.setStave(this.stave);
      this.keySignature.format();
      this.setWidth(this.keySignature.width);
      return this;
    }
  }, {
    key: "draw",
    value: function draw() {
      this.stave.checkContext();
      this.setRendered();
      this.keySignature.x = this.getAbsoluteX();
      this.keySignature.setContext(this.context);
      this.keySignature.draw();
    }
  }]);

  return KeySigNote;
}(Note);